const columnsRenderersConfig = {
  
};

export default columnsRenderersConfig;